export default "__VITE_ASSET__e5be2f2a__"